import React from "react";
import { DynamicForm } from "../../../common";
import { useSteadyState } from "../useSteadyState";
import { useAnalytics } from "../../../../../analytics";
export var SteadyStateEditor = function (_a) {
    var value = _a.value, onSave = _a.onSave, onCancel = _a.onCancel;
    var _b = useSteadyState(value), steadyState = _b.steadyState, fields = _b.fields;
    var sendUIEvent = useAnalytics().sendUIEvent;
    var onSubmit = function () {
        sendUIEvent({
            source: "createWargamePlanTaskGroupDefinitionStep",
            actionSubject: "button",
            action: "clicked",
            actionSubjectId: "addSteadyState",
            attributes: {
                steadyState: steadyState
            }
        });
        onSave(steadyState);
    };
    return (React.createElement(DynamicForm, { fields: fields, submitButtonText: "Add Stop Condition", onSubmit: onSubmit, onCancel: onCancel }));
};
